import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import Loader from 'react-loader-spinner';

const Api = require('./Config');

const MessageSendDialog = ({ show, app_id, onClose, t_code, sendAction, staticTemplate, isLoading = false }) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [tCodes, setTCodes] = useState([]);

  useEffect(() => {
    (async () => {
      let items = [];
      let selected = null;

      if (staticTemplate) {
        items = [staticTemplate];
      } else {
        const templates = await Api.getAllTemplates(app_id);
        items = templates?.data;
      }

      if (items && items.length > 0) {
        selected = items[0];
      }

      setTemplates(items);
      setSelectedTemplate(selected);

      const tcodes = !Array.isArray(t_code) ? [t_code] : t_code;
      setTCodes(tcodes);
    })();
  }, [t_code]);

  return (
    <Modal show={show} onHide={onClose} autoFocus={false}>
      <Modal.Header>
        <Modal.Title>
          Send Message To {tCodes && tCodes.length > 1 ? `${tCodes.length} T-Codes` : tCodes[0]}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label>Message Use</label>
          <select
            value={selectedTemplate?.id || ''}
            onChange={(e) => {
              const selectedTemp = _.find(templates, (a) => a.id === e.target.value);
              setSelectedTemplate(selectedTemp);
            }}
            className="form-control"
          >
            {templates.length > 0 &&
              templates.map((template) => (
                <option value={template.id} key={template.id + template.view_title}>
                  {template.view_title}
                </option>
              ))}
          </select>
        </div>
        <div className="form-group">
          <label>Alert that will appear on phone</label>
          <textarea readOnly value={selectedTemplate?.title || ''} className="form-control" />
        </div>
        <div className="form-group">
          <label>Message</label>
          <textarea readOnly value={selectedTemplate?.body || ''} className="form-control" />
        </div>
        <div className="form-group">
          <label>Link</label>
          <input readOnly value={selectedTemplate?.link || ''} type="text" className="form-control" />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          onClick={() =>
            sendAction(
              selectedTemplate?.title || '',
              selectedTemplate?.body || '',
              selectedTemplate?.link || '',
              selectedTemplate?.category_id || ''
            )
          }
          className="btn btn-success"
        >
          {isLoading ? <Loader type="Oval" color="#00BFFF" height={30} width={30} /> : 'Send'}
        </button>
        <button type="button" onClick={onClose} className="btn btn-info">
          {isLoading ? <Loader type="Oval" color="#00BFFF" height={30} width={30} /> : 'Cancel'}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageSendDialog;
